import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"

type ModelArg = {
  layout: string
  startDate?: string
  endDate?: string
  planbookId: string
  courseId?: string
  courseIds?: string[]
  unitId: string
  isFilteringClasses: boolean
  classesLinedUp: boolean
  medium: string
  currentUserId: string
  dateRangeString: string
  canPrint: boolean
  standardSetId?: string | null
  showStandardsNotCovered?: boolean
}

export default class PrintDownload extends Component {
  // Args
  model!: ModelArg

  // Services
  @service("ember-store") store!: EmberStore
  @service modalManager!: ModalManager
}
